<template>
  <div class="chart-menu">
    <div v-bind:class="'submenu_'+this.parentData">
      <div class="underline"></div>
      <div class="menuitem" @click="ul(index)" v-for="(item, index) in chartsSelected" :key="index">
        <span class="menutext">{{item.pool}}</span>
        <v-badge
          v-bind:color="item.activity > 0 ? '#25A7F9' : '#808F9C'"
          overlap
          class="align-self-center"
        >
          <template v-slot:badge>
            <span class="my-vbadge">0</span>
          </template>
        </v-badge>
      </div>
      <div class="menuitem mr-4">
        <modalsSettings :type="this.parentData" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import modalsSettings from "./settings";

export default {
  props: ["parentData"],

  components: {
    modalsSettings
  },

  data() {
    return {
      name: "Submenu",
      selected: this.userSubmenus[this.parentData].selected
    };
  },
  computed: {
    ...mapGetters([
      "username",
      "timezone",
      "markets",
      "userSubmenus",
      "chartSubmenus"
    ]),
    chartsSelected() {
      if (this.userSubmenus[this.parentData].items.length == 0) {
        var makeSubmenu = this.markets.slice(-4);
        return makeSubmenu;
      } else {
        return this.userSubmenus[this.parentData].items;
      }
    }
  },
  watch: {
    chartSubmenus() {
      this.ul(0);
    }
  },
  methods: {
    // submenu click

    ul(newSelection) {
      //if (this.parentData == 0) this.$store.dispatch("CHANGE_DATA", index);

      if (this.userSubmenus[this.parentData].items.length > 0) {
        this.$store.dispatch("updateSubmenu", {
          section: this.parentData,
          value: newSelection
        });

        var selectedIndex = newSelection;

        this.$emit("chartTitle", selectedIndex);
        //var itemsArray = this.$store.getters.userSubmenus[this.parentData].items;
        //var selectedIndex = itemsArray.indexOf(selectedItem);

        var menuitem = document.querySelectorAll(
          ".submenu_" + this.parentData + " .menuitem"
        );
        var menutext = document.querySelectorAll(
          ".submenu_" + this.parentData + " .menuitem .menutext"
        );

        for (var i = 0; i < menutext.length; i++) {
          menutext[i].style.color = null;
        }
        menutext[selectedIndex].style.color = "#FFFFFF";
        var width = menutext[selectedIndex].offsetWidth;
        var x = menuitem[selectedIndex].offsetLeft;
        var underlines = document.querySelectorAll(
          ".submenu_" + this.parentData + " .underline"
        );
        underlines[0].style.width = width + "px";
        underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
      }
    }
  },
  mounted() {
    //var itemsArray = this.$store.getters.userSubmenus[this.parentData].items;
    //var selectedIndex = itemsArray.indexOf(selectedItem);
    if (
      this.userSubmenus[this.parentData].items.length == 0 &&
      this.markets.length > 0
    ) {
      var makeSubmenu = this.markets.slice(-4);

      this.$store
        .dispatch("API_UPDATE_SETTINGS", {
          key: "submenus.Section0.items",
          newValue: makeSubmenu
        })
        .then(() => {});
    }
    setTimeout(() => {
      var selectedIndex = this.$store.getters.userSubmenus[this.parentData].selected;
      // initial submenut underline (after short timeout)
      this.ul(selectedIndex);
    }, 200);
  }
};
</script>

<style scoped>
</style>
